import * as z from 'zod'

export const NullishSchema = z.undefined().nullable()
export type NullishSchame = z.infer<typeof NullishSchema>

export const isNullish = (value: unknown): value is null | undefined =>
  value === null || typeof value === 'undefined'
